import { useQuery } from '@tanstack/react-query';
import { getNurturingFunnel } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useNurturingFunnel() {
  const query = useQuery({
    queryKey: ['nurturing', 'funnel'],
    queryFn: () => getNurturingFunnel(PARTNER_ID),
  });
  return { funnel: query.data?.data ?? null, isLoading: query.isLoading, isError: query.isError, refetch: query.refetch };
}
